import { Table as AntTable } from 'antd';
import { classNames } from 'src/utilities';
import { Bars } from 'react-loader-spinner';

export const SuperAdminTable = ({
  className,
  columns,
  data,
  loading,
  onRowClick,
}) => {
  return (
    <div className={classNames('table', className ? className : '')}>
      <AntTable
        columns={columns}
        sortDirections={['ascend', 'descend', 'ascend']}
        showSorterTooltip={false}
        dataSource={data || []}
        loading={{
          indicator: (
            <>
              <Bars
                height="25"
                width="25"
                color="#00D090"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass="pt-1 sm:pt-2 justify-center"
                visible={true}
              />
            </>
          ),
          spinning: loading,
        }}
        pagination={false}
        locale={{
          emptyText: 'No Data',
        }}
        onChange={() => null}
        onRow={onRowClick}
      />
    </div>
  );
};
